<template>
  <div class="font-roboto">
    <Breadcrumbs :title="$t('lbl_EMPBE_SourcingTrendAndMarketAnalysis')" />
    <div class="wrapper">
      <div
        class="mb-0 f-24 d-flex justify-content-between align-items-center gap-3 w-100"
      >
        <div class="h6">
          {{ pageDesc }}
          <i
            class="fa fa-info-circle f-16 m-l-5"
            @click="isLocationInfoOpened = true"
            style="cursor: pointer"
          />
        </div>

        <div class="flex-grow-0 flex-shrink-0 flex-basis-auto">
          <b-button variant="info" :href="userGuidePath" target="_blank">
            {{ userGuideText }}
          </b-button>
        </div>
      </div>

      <STMAGrid ref="STMAGrid" />
    </div>

    <div>
      <div
        class="b-sidebar-backdrop bg-dark"
        style="z-index: 100"
        v-if="isDetailOpened"
        @click="onHideSidebar"
      ></div>
      <b-sidebar
        id="sideBarPopup"
        right
        bg-variant="white"
        :shadow="true"
        v-model="isDetailOpened"
        ref="sideBarPopup"
        no-header
        :no-close-on-esc="true"
        :no-close-on-route-change="true"
      >
        <router-view ref="currentItem" />
      </b-sidebar>
    </div>

    <div>
      <div
        class="b-sidebar-backdrop bg-dark"
        style="z-index: 100"
        v-if="isLocationInfoOpened"
        @click="isLocationInfoOpened = false"
      ></div>

      <b-sidebar
        id="locationInfoSideBarPopup"
        right
        bg-variant="white"
        :shadow="true"
        v-model="isLocationInfoOpened"
        ref="locationInfoSideBarPopup"
        no-header
      >
        <div class="h-100">
          <div
            class="sticky-top p-20 f-24 font-weight-bold border-bottom d-flex justify-content-between align-items-center bg-white"
          >
            <span>
              {{ $t("lbl_EMPBE_SourcingTrendAndMarketAnalysis") }}
            </span>

            <button
              class="close-sidebar-btn"
              type="button"
              @click="isLocationInfoOpened = false"
            >
              <i class="icon-close f-14" />
            </button>
          </div>
          <div class="p-20 w-100">
            <img class="w-100" :src="locationInfoImageSrc" />
          </div>
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import STMAGrid from "./components/grid";

export default {
  components: {
    STMAGrid,
  },
  data() {
    return {
      isDetailOpened: this.$route.name !== "SourcingTrendAndMarketAnalysis",
      isLocationInfoOpened: false,
    };
  },

  watch: {
    currentRouteName: {
      handler() {
        this.$nextTick(() => {
          const isDetailOpened =
            this.currentRouteName !== "SourcingTrendAndMarketAnalysis";
          this.isDetailOpened = isDetailOpened;

          // Force background to be not scrollable
          if (isDetailOpened) {
            document.body.style.overflow = "hidden";
          } else {
            document.body.style.overflowY = "scroll";
          }
        });
      },
    },

    isLocationInfoOpened: {
      handler() {
        if (this.isLocationInfoOpened) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflowY = "scroll";
        }
      },
    },
  },

  computed: {
    currentRouteName() {
      return this.$route.name;
    },

    localeKey() {
      const langId = localStorage.getItem("currentLangId");

      return langId === "1252"
        ? "EN"
        : langId === "936"
        ? "SC"
        : langId === "950"
        ? "TC"
        : "TC";
    },

    locationInfoImageSrc() {
      const localeKey = this.localeKey;

      const imgSrcMap = {
        EN: "https://cdn.adsalecdn.com/EMP/Backend/Images/1252/SourcingTrend_Location_EN.png",
        TC: "https://cdn.adsalecdn.com/EMP/Backend/Images/950/SourcingTrend_Location_TC.png",
        SC: "https://cdn.adsalecdn.com/EMP/Backend/Images/936/SourcingTrend_Location_SC.png",
      };

      return imgSrcMap[localeKey];
    },

    pageDesc() {
      const localeKey = this.localeKey;

      const pageDescMap = {
        EN: "Updating sourcing trend and market analysis content will directly update the content displayed on the EMP supplier backend website",
        TC: "更新採購趨勢和市場分析內容將直接更新EMP供應商後台網站裏所展示的內容",
        SC: "更新采购趋势和市场分析內容将直接更新EMP供应商后台网站里所展示的内容",
      };

      return pageDescMap[localeKey];
    },

    userGuidePath() {
      return "https://cdn.adsalecdn.com/EMP/Backend/pdf/STMA_User_Guide_20240605_CN.pdf";
    },

    userGuideText() {
      const localeKey = this.localeKey;

      const userGuideMap = {
        EN: "User Guide",
        TC: "使用者指南",
        SC: "用户指南",
      };

      return userGuideMap[localeKey];
    },
  },

  methods: {
    onHideSidebar() {
      this.$refs.currentItem.onCloseDetail();
    },

    onShowLocationInfo() {
      this.isLocationInfoOpened = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./style/default";
</style>
